import Button from "@components/elements/button"
import Card from "@components/common/card"
import React from "react"
import styled, { useTheme } from "styled-components"
import PropTypes from "prop-types"
import { useCta } from "@hooks/use-cta"
import { PRODUCTS } from "@hooks/use-product"
import Heading from "@components/elements/heading"
import Paragraph from "@components/elements/paragraph"
import Span from "@components/elements/span"

const StyledButtonLine = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.4;
  font-weight: bold;
  color: white;
  line-height: 22px;
  margin: 11px 0;
  ::after,
  ::before {
    content: " ";
    transform: translateY(2px);
    opacity: 0.4;
    height: 2px;
    flex: 1;
    background-color: white;
  }
`

const SignUpCTA = ({ category, style }) => {
  const { ctaLink, product } = useCta(false, null, null)
  const { color } = useTheme()

  return (
    <Card
      id="appSignup"
      style={{ maxWidth: "450px", background: color.blue600, ...style }}
    >
      <Heading color="white" fontSize="1.6rem" margin="0 0 1rem" as="h2">
        Track all your {category} KPIs in one place
      </Heading>
      <Paragraph
        color="white"
        fontSize="1.1rem"
        lineHeight="1.5"
        margin="0 0 2rem"
      >
        Sign up for <b>free</b> and start making decisions for your business
        with confidence.
      </Paragraph>
      <Button.Google data-cta-location="header" notice={false} />
      <StyledButtonLine>or</StyledButtonLine>
      <Button
        data-cta-location="header"
        href={ctaLink}
        background={color.blue400}
        center
        notice={false}
      >
        Sign up with your email
      </Button>
      <Span display="block" margin=".5rem auto 0" color="white" opacity={0.4} fontSize="0.7rem" fontWeight="bold">{`${
        product === PRODUCTS.POWERMETRICS ? `Free forever` : `Free for 14 days`
      } ● No credit card required`}</Span>
    </Card>
  )
}

SignUpCTA.propTypes = {
  category: PropTypes.string,
  powerMetrics: PropTypes.bool,
  style: PropTypes.object,
}

export default SignUpCTA
